angular.module('rjmNg.directives').directive "replicationMethod", [
  "dataWarehouse"
  (dataWarehouse) ->
    restrict: "E"
    templateUrl: "directive.replicationMethod.html"
    replace: true
    scope:
      table: "="
      remoteDbType: "="
      newTable: "="
    controllerAs: 'view'
    bindToController: true
    controller: [
      "Tables"
      "replicationService"
      "notification"
      "emailNotificationService"
      "email"
      "logger"
      "jobService"
      "jobTypes"
      (
        Tables
        replicationService
        notification
        emailNotificationService
        email
        logger
        jobService
        jobTypes
      ) ->
        view = @

        view.selectedFull = true

        view.save = (runBackgroundSync) ->
          save(view.modifiedTable.replicator.type, view.modifiedTable.replicator.modified_sid, runBackgroundSync)

        view.isChanged = () ->
          not angular.equals(view.table, view.modifiedTable) or view.newTable

        view.needsColumnId = (method) ->
          replicationService.needsColumnId(method)

        view.getColumnNameFromId = (id) ->
          unless id?
            return "Select a column"
          for col in view.modifiedTable.columns when col.id is +id
            return col.name
          return "Column ${id}"

        view.repMethodDocUrl = dataWarehouse.REPLICATION_METHOD_DOC_URL

        view.displayedReplicationMethod = (method, category) ->
          replicationService.getDisplayedName(method, category)

        view.getAllowedMethods = (methods) ->
          filtered = []
          if view.table?
            allowed = replicationService.getAllowedReplicationMethods(
              view.remoteDbType, view.table.columns
            )
            filtered = (method for method in methods when method in allowed)
          return filtered

        view.getValidColumns = () ->
          replicationService.getReplicationKeys(view.modifiedTable.columns, view.modifiedTable.replicator.type)

        save = (replicationMethod, columnId, runBackgroundSync) ->
          replicator = getReplicator(replicationMethod, columnId)

          # Grab the table, and replace the replicator
          Tables.get(view.modifiedTable.id).then( (table) ->
            saveTable(table, replicator, runBackgroundSync)
          , handleError)

        saveTable = (table, replicator, runBackgroundSync) ->
          table.replicator = replicator

          # We need to delete this until the schema service can handle it
          delete table.remote_table

          Tables.save(table).then( (success) ->
            handleSuccess(success, replicator, runBackgroundSync)
          , handleError)

        getReplicator = (method, columnId) ->
          unless replicationService.needsColumnId(method)
            columnId = null
          replicator =
            type: method
            modified_sid: columnId

        handleSuccess = (success, replicator, runBackgroundSync) ->
          # Update DWM's copy
          view.table.replicator = replicator

          logger.log('Replication Modal Usage', 'Save', 1, replicator.type)
          notification.success('Success', 'The replication method has been set.', 'global')

          if runBackgroundSync
            syncTable(view.table.id)

        syncTable = (tableId) ->
          workload =
            tableId: tableId
            interruptRunningSync: false
          successSync = () ->
            notification.success('Success', 'We have queued a background sync for this table', 'global')
          failSync = () ->
            notification.error('Error', 'Unable to queue a background sync for this table', 'global')
          # Request an email to the user when the background sync starts and completes
          emailNotificationService.post(email.TYPE.BACKGROUND_SYNC_START)
          emailNotificationService.post(email.TYPE.BACKGROUND_SYNC_COMPLETION)
          jobService(jobTypes.BACKGROUND_DATA_SYNC).queue(workload, successSync, failSync)
          return true

        handleError = (errorMessage) ->
          notification.error('Server Error',
            'We encountered a problem setting the replication method for this table.
            Please contact support.', 'global')

        @$onInit = ->
          view.modifiedTable = angular.copy(view.table)

        view
   ]
    link: (scope, elem, attrs, view) ->

      view.incrementalMethods = view.getAllowedMethods(dataWarehouse.REPLICATION_INCREMENTAL)
      view.fullMethods = view.getAllowedMethods(dataWarehouse.REPLICATION_FULL)

      scope.$watch 'view.fullMethods', () ->
        if view.modifiedTable?
          view.selectedFull = view.modifiedTable.replicator.type in view.fullMethods
          view.validColumns = view.getValidColumns()
]
